import { Pipe, PipeTransform } from '@angular/core';
import { rus } from '@models/utils/strings';

@Pipe({ name: 'rus' })
export class RusPipe implements PipeTransform {
    transform(value: any, suffixes: [string, string, string, string, string, string]): string {
        return rus(value, suffixes);
    }
}

